import { useAuthenticator } from "auth/useAuthenticator";
import { useCallback } from "react";
import { useAppDispatch } from "store/hooks";
import { showSpinner, hideSpinner } from "store/reducers/spinnerReducer";

export const useCreateApiCall = () => {
  const dispatch = useAppDispatch();
  const { handleAuthError } = useAuthenticator();

  const createApiCall = useCallback(
    (callbackFn, errorCallbackFn = null, silentMode = false) => async (...args) => {
      if (!silentMode) dispatch(showSpinner());
      try {
        const result = await callbackFn(...args);
        return result;
      } catch (err) {
        if (errorCallbackFn) {
          errorCallbackFn(err);
        } else {
          handleAuthError(err);
        }
      } finally {
        if (!silentMode) dispatch(hideSpinner());
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return { createApiCall };
};
